import React from "react";
import CustomModal from "../../../../components/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../../service/validation/newCargo";
import Input from "../../../../components/FormInputs";
import UnitDropDown from "../../../../components/Dropdown/unitDropdown";
import { AddNewCargoProps, NewCargoFormValues } from "../../../../service/interfaces/Forms";

const AddNewCargo: React.FC<AddNewCargoProps> = ({
  isModalOpen,
  setIsModalOpen,
  cargoData,
  setCargoData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
    watch,
    control,
    setValue,
  } = useForm<NewCargoFormValues>({
    resolver: yupResolver(validationSchema) as any,
  });
  const Submit = (data: NewCargoFormValues) => {
    if(data){
      let newData = {
        cargoItem: data.cargoItem,
        cargoType: data.cargoType,
        volume: data.volume, // Keep as number
        volume_unit: data.volume_unit, // Add unit separately
        weight: data.weight, // Keep as number
        weight_unit: data.weight_unit, // Add unit separately
        count: data.count,
        packageType: data.packageType,
      }
      setCargoData && setCargoData([...(cargoData || []), newData]);
      setIsModalOpen(false);
      reset();
    }
    // console.log(data);
  };
  const cancel = () => {
    setIsModalOpen(false);
    reset();
  };
  return (
    <div>
      <CustomModal
        isOpen={isModalOpen}
        title="Add Cargo"
        width="600px"
        onClose={() => setIsModalOpen(false)}
        content={
          <div>
            <form
              onSubmit={handleSubmit(Submit)}
            >
                <div className="grid grid-cols-2 gap-4">
              <Input
                register={register}
                name="cargoItem"
                errors={errors}
                label="Cargo Item"
                placeholder="Cargo Item"
                type="text"
                onBlur={() => trigger("cargoItem")}
              />
              <Input
                register={register}
                name="cargoType"
                errors={errors}
                label="Cargo Type"
                placeholder="Cargo Type"
                type="text"
                onBlur={() => trigger("cargoType")}
              />
              <UnitDropDown
                label=" Volume"
                name="volume"
                errors={errors}
                placeholder="Enter Volume"
                unitOptions={["Unit", "Kg", "Lbs"]}
                register={register}
                required
                onBlur={() => trigger("volume")}
                //   selectedValue={volume}
                //   selectedUnit={volume_unit}
              />
              <UnitDropDown
                label=" Weight"
                name="weight"
                errors={errors}
                placeholder="Enter Weight"
                unitOptions={["Unit", "Kg", "Lbs"]}
                register={register}
                required
                //   selectedValue={volume}
                //   selectedUnit={volume_unit}
              />
              <Input
                register={register}
                name="count"
                errors={errors}
                label="Count"
                placeholder="Count"
                type="number"
                onBlur={() => trigger("count")}
              />
              <Input
                register={register}
                name="packageType"
                errors={errors}
                label="Package Type"
                placeholder="Package Type"
                type="text"
                onBlur={() => trigger("packageType")}
              />
              </div>
              <div className="flex gap-4 justify-end mt-4">
                <button
                  type="button"
                  onClick={cancel}
                  className="w-36 h-10 rounded-lg text-[#444FBD] border border-[#444FBD] hover:border-gray-400 transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSubmit(Submit)}
                  className="w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        }
      />
    </div>
  );
};

export default AddNewCargo;
